import React from 'react';
import { useRecoilValue } from 'recoil';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  controlPointsState,
  ySymmetryState,
  targetControlPointsXState,
  targetControlPointsYState,
  targetControlPointsZState,
} from 'features/morphing/state/stageParameterAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { SliceForm } from './forms/SliceForm';
import { SymmetryForm } from './forms/SymmetryForm';

interface Props {
  subtitle: string;
}

export const TargetControlPointsForm: React.FC<Props> = ({ subtitle }) => {
  const controlPoints = useRecoilValue(controlPointsState);

  return (
    <Accordion sx={{ backgroundColor: '#404040', color: '#333' }}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="cfd-content"
        id="cfd-header"
      >
        <CustomTypography >{subtitle}</CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Box component="div">
          <SymmetryForm
            booleanState={ySymmetryState}
            label={"XZ-plane symmetry"}
            sliceState={targetControlPointsYState}
            maxValue={controlPoints.y}
          />
          <SliceForm
            sliceState={targetControlPointsXState}
            label={"X-axis"}
            maxValue={controlPoints.x}
          />
        </Box>
        <Box component="div">
          <SliceForm
            sliceState={targetControlPointsYState}
            label={"Y-axis"}
            maxValue={controlPoints.y}
          />
        </Box>
        <Box component="div">
          <SliceForm
            sliceState={targetControlPointsZState}
            label={"Z-axis"}
            maxValue={controlPoints.z}
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
